import { PureComponent } from "react";
import BaseTemplate from "components/templates/base-template";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component";
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component";
import { errorCareersCommonStyles } from "./error-careers-common-styls.scss";

export default class ErrorCareersComponent extends PureComponent {
  getMessage = () => {
    const { statusCode } = this.props;
    if (statusCode === 404 || statusCode === 410) return "Position not found";
    return "Sorry, something went wrong";
  };

  render() {
    return (
      <BaseTemplate {...this.props}>
        <BaseHeaderComponent />
        <div className="error-careers-component">
          <div className="error-message">
            <img className="cactus" src="/static/img/careers/cactus.png" />
            <span className="title">{this.getMessage()}</span>
            <div className="content">
              You can still apply. We're always looking for amazing people!{" "}
              <a href="/careers/unlisted">submit your resume</a> and we’ll get in touch if anything comes up.
            </div>
          </div>
        </div>
        <LongFooterComponent />

        <style jsx>{errorCareersCommonStyles}</style>
      </BaseTemplate>
    );
  }
}
